// do NOT indent code
// replace :url in component
export const ROUNDS_IFRAME: string =
`<iframe
  id="iframe-rounds-auto"
  src=":url"
  width="100%"
  height="300"
  frameborder="0"
  scrolling="no"
  style="border: none; overflow: hidden;">
</iframe>

<script>
  window.addEventListener("message", function(e) {
    var iframe = document.getElementById("iframe-rounds-auto");
    if (e.data && e.data.iframeRoundsHeight) {
      iframe.style.height = e.data.iframeRoundsHeight + "px";
    }
  });
</script>`;